export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активація електронного чека"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок зарахування"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Серія"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код активації"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевірити"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активувати"])}
}